import { Card, CardContent, CardHeader, Dialog, Link, Slide } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import { createStyles, StyledComponentProps, Theme, withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { TransitionProps } from '@material-ui/core/transitions/transition';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import lDbgImage from '../assets/bg_login.jpg';
import { LogoIcon } from '../LogoIcon';
import { transl } from '../main/transl';
import { commSvc } from '../services/CommSvc';
import { toasterSvc } from '../services/ToasterSvc';
import { getOmnistore } from '../stores/Omnistore';
import { RegistrationDialog } from './RegistrationDialog';

// eslint-disable-next-line react/display-name
const Transition = React.forwardRef((props: TransitionProps, ref) => <Slide direction="up" {...props} ref={ref}/>);

@observer export class _LoginDialog extends React.Component<StyledComponentProps> {
	@computed get _omnistore() {
		return getOmnistore();
	}

	@computed get _authStore() {
		return this._omnistore.authStore;
	}

	@computed get _registrationDialogStore() {
		return this._omnistore.appPageStores.registrationDialogStore; //REOCTOBUILD
		//return null as any // "!app" //REOCTOBUILD
	}

	@observable _state = {
		password: '',
		showPassword: false,
	}

	@observable _isVisited = {} //TODO use or remove

	@action _onChange = (event: React.ChangeEvent<HTMLInputElement>) => (this._state as any)[event.currentTarget.name] = event.currentTarget.value

	@action _onEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => this._authStore.setEmail(event.currentTarget.value)

	@action _onShowPasswordChange = () => this._state.showPassword = !this._state.showPassword

	@action _submit = () => {
		this._authStore.sanitize();
		commSvc.login(this._state.password)
			.then(commSvc.requireOutputList)
			.catch(toasterSvc.failure);
		this._state.password = '';
	}

	@action _onFocus = (event: React.MouseEvent<HTMLInputElement>) => (this._isVisited as any)[event.currentTarget.name] = 1

	@action _onKeyPress = (event: React.KeyboardEvent) => event.charCode === 13 ? this._submit() : null

	@action _startRegistration = () => this._registrationDialogStore.start(this._authStore.email)

	@action _startRecovery = () => {
		this._registrationDialogStore.reset(this._authStore.email);

	}

	@computed get _disabled() {
		return !this._authStore.email || !this._state.password;
	}

	render() {
		const classes = this.props.classes || {};
		return <Dialog
			fullScreen
			open={!this._authStore.authorization}
			TransitionComponent={Transition}
			className={classes.root}
		>
			<div className={classes.rootDialog} >
				<div className={classes.logoContainer}><LogoIcon className={classes.logo} /></div>

				<Card className={classes.card}>
					<CardHeader className={classes.cardHeader} title={transl('loginTitle')} subheader={transl('loginHeading')}
						classes={{ title: classes.MuiCardHeader_title, subheader: classes.MuiCardHeader_subheader }}
					/>
					<CardContent className={classes.cardContent}>
						<TextField
							required
							// error={!this._authStore.email}
							type="email"
							// label={transl('email')}
							className={classes.textField}
							name="email"
							id="email_l"
							placeholder={transl('email')}
							value={this._authStore.email}
							onChange={this._onEmailChange}
							onKeyPress={this._onKeyPress}
							variant="filled"
						// InputLabelProps={{ shrink: true }}
						/>
						<TextField
							required
							error={!this._state.password}
							className={classes.textField}
							type={this._state.showPassword ? 'text' : 'password'}
							// label={transl('password')}
							placeholder={transl('password')}
							name="password"
							id="password_l"
							value={this._state.password}
							onChange={this._onChange}
							onKeyPress={this._onKeyPress}
							variant="filled"
							// InputLabelProps={{ shrink: true }}
							InputProps={{
								endAdornment: (
									<InputAdornment position="end">
										<IconButton onClick={this._onShowPasswordChange} aria-label="Toggle password visibility">
											{this._state.showPassword ? <VisibilityOff /> : <Visibility />}
										</IconButton>
									</InputAdornment>
								),
							}}
						/>
						<Button variant="contained" color="primary" className={classes.button} onClick={this._submit} disabled={this._disabled}>
							{transl('action.login')}
						</Button>
						{
							<Link className={classes.linkPassword} onClick={this._startRecovery}>{transl('recoverPassword')}</Link>
						}
						{
							<Link className={classes.linkNewAccout_login} onClick={this._startRegistration}>{transl('register')}</Link>
						}
					</CardContent>
				</Card>
				<RegistrationDialog store={this._registrationDialogStore} classes={classes} />
			</div>
		</Dialog>;
	}
}

const styles = (theme: Theme) => createStyles({
	rootDialog: {
		fontFamily: '"TT Hoves", "Roboto", "Helvetica", "Arial", sans-serif',
		letterSpacing: 'normal',
	},
	MuiCardHeader_title: {
		color: 'rgba(0, 0, 0, 1)',
		lineHeight: '2',
		fontWeight: 'bold',
		fontFamily: 'inherit',
		letterSpacing: 'inherit'
	},
	MuiCardHeader_subheader: {
		color: 'rgba(0, 0, 0, 0.87)',
		fontSize: '1.1rem',
		lineHeight: 'normal',
		fontFamily: 'inherit',
		letterSpacing: 'inherit'
	},

	card: {
		flex: 1,
		width: '320px',
		margin: '20px auto',
		borderRadius: '10px',
		backgroundColor: '#fff'
	},
	cardHeader: {
		padding: '25px 30px',
		paddingBottom: '0px',
	},
	cardContent: {
		marginTop: '16px',
		padding: '30px',
		paddingTop: '0px',
		paddingBottom: '10px !important'
	},

	root: {
		flexDirection: 'column',
		flexWrap: 'wrap',
		justifyContent: 'center',
		position: 'relative',
		'& .MuiDialog-container': {
			backgroundColor: '#fff',
			backgroundImage: `url(${lDbgImage})`,
			height: '100%',
			backgroundSize: 'cover',

		},
		'& .MuiPaper-root.MuiDialog-paper': {
			backgroundColor: 'transparent'
		}
	},

	textField: {
		margin: '5px 0',
		width: '100%',
		'& .MuiInputBase-root': {
			borderRadius: '8px',
			border: '0px solid #f7f7f7',
			backgroundColor: '#f7f7f7',
		},

		'& .MuiFilledInput-underline:before': {
			borderBottom: '0px',
			borderRadius: '8px'
		},
		'& .MuiFilledInput-underline:hover:before': {
			borderBottom: '0px'
		},
		'& .MuiFilledInput-input': {
			padding: '10px 15px 8px'
		},
		'& .MuiFilledInput-underline:after': {
			borderBottom: '0px',
			borderRadius: '8px'
		},
		'& .Mui-error': {
			border: '0px solid  #b9747a',
			boxShadow: '0px 0px 2px 1.5px #b9747a'
		},
		'& .MuiInputBase-root.Mui-focused': {
			border: '0px solid #eaeaea',
			backgroundColor: '#eaeaea',
			boxShadow: 'none'
		},
	},
	button: {
		margin: '20px auto',
		backgroundColor: '#5b49dd',
		fontWeight: 'bold',
		padding: '5px 25px',
		'&.MuiButton-containedPrimary:hover': {
			backgroundColor: 'rgba(205,0,88,0.87)'
		}
	},
	linkPassword: {
		margin: '10px',
		display: 'inline-block',
		cursor: 'pointer',
		color: 'rgba(0, 0, 0, 0.87)'
	},
	linkNewAccout_login: {
		display: 'inline-flex',
		margin: '15px auto',
		cursor: 'pointer',
		color: 'rgba(0, 0, 0, 1)',
		fontWeight: 'bold',
		fontSize: '14px'

	},
	logoContainer: {
		margin: '20px auto',
		textAlign: 'center'
	},
	logo: {
		display: 'inline-block',
		height: '16em',
		[theme.breakpoints.down('xs')]: {
			height: '12.5em',
		},
	},
});

export const LoginDialog = withStyles(styles)(_LoginDialog);
